import { IIntegration } from '@principle-theorem/integrations';
import { CollectionReference } from '@principle-theorem/shared';
import { ITemporaryOrgToken } from '@principle-theorem/temporary-tokens';

export interface IIntegrationDialogData<T extends object = object> {
  orgUid: string;
  integrationsCol: CollectionReference<IIntegration<T>>;
  temporaryTokensCol: CollectionReference<ITemporaryOrgToken>;
}
